export const CORPS_WITH_PATIENT_QUERY = [
  43, //Cruz Nacional
]

export const baseURL =
  process.env.REACT_APP_API_URL || `http://localhost:4000/api/v1`
